module.exports = __webpack_public_path__ + "static/Plaak - 43-Pradel-Bold-205TF-fb59ef362938c6bcbd33d22e47f0a223.woff";